import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { logout } from '../features/auth/authSplice'
import {store} from '../store'
import {showSnack} from '../features/snacks/snackService'
import {ErrorData} from './types';

export const configureAxios = (): AxiosInstance => {
    const axiosInstance: AxiosInstance = axios.create()
    const host: string = typeof process.env.REACT_APP_BACKEND_URL == 'string' ? process.env.REACT_APP_BACKEND_URL : ''
    axiosInstance.defaults.baseURL = host

    axiosInstance.interceptors.response.use((response: AxiosResponse) => {
        return response
    }, async (error: AxiosError<ErrorData[]>): Promise<AxiosResponse<any>> => {
        if (!error.response) {
            return Promise.reject(error);
        }
        if (error.response.status === 401) {
            if (authToken()) {
                const logoutMe = () => store.dispatch(logout())
                logoutMe()
            }
        }
        const message = error.response.data.length > 0 ? error.response.data[0].messages[0] : error.response.statusText;
        showSnack(message, 'error')

        return Promise.reject(error)
    })

    axiosInstance.interceptors.request.use((config)=>{
        const token = authToken()
        const isLoggedIn = !!token
        const freeRequests = ['login']
        const isFreeRequest = config.url && freeRequests.includes(config.url.split('?')[0])
        if (isLoggedIn && !isFreeRequest) {
            config['headers'] = config.headers ?? {};
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config
    })

    return axiosInstance
}

function authToken() {
    return store.getState().auth.token
}
